// Added by Sejune Oh on 2019-03-08
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { GetQueryParams, GetQueryReturn, API_VERSION } from '../../helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Store
import Rootstore from '../../stores'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface RegistryStoreBaseConstructorProps {
    storeName: string
    apiUrl: string
    _root: Rootstore
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class RegistryStoreBase<T> {
    storeName: string = ''
    apiUrl: string = ''
    _root: Rootstore

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    constructor({ storeName, apiUrl, _root }: RegistryStoreBaseConstructorProps) {
        this.storeName = storeName
        this.apiUrl = `${API_VERSION}/${apiUrl}`
        this._root = _root
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    getQueryPath = ({ pageIndex = 0, pageSize, order = 'desc', orderBy, filter }: GetQueryParams): string => {
        const queries = []
        queries.push(`page_index=${pageIndex + 1}`)

        if (pageSize) {
            queries.push(`page_size=${pageSize}`)
        }

        if (orderBy) {
            queries.push(`order_by=${orderBy}:${order}`)
        }

        if (filter) {
            queries.push(`filter=${filter}`)
        }

        return queries.join('&')
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    get(key: string): Promise<T> {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: elementInfo } = await axios.get<T>(`${this.apiUrl}/${key}`)
                resolve(elementInfo)
            } catch (err) {
                reject(err)
            }
        })
    }

    getFullResponse(key: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                resolve(await axios.get<T>(`${this.apiUrl}/${key}`))
            } catch (err) {
                reject(err)
            }
        })
    }

    getAll(path: string): Promise<GetQueryReturn<T>> {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: rtnData } = await axios.get<GetQueryReturn<T>>(`${this.apiUrl}?${path}`)
                resolve(rtnData)
            } catch (err) {
                reject(err)
            }
        })
    }

    add(element: T): Promise<T> {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: rtnElement } = await axios.post<T>(`${this.apiUrl}`, {
                    ...element,
                })

                resolve(rtnElement)
            } catch (err) {
                reject(err)
            }
        })
    }

    remove(key: string): Promise<{}> {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.delete(`${this.apiUrl}/${key}`)
                resolve(true)
            } catch (err) {
                reject(err)
            }
        })
    }

    update(key: string, element: T, subPath = ''): Promise<T> {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: rntElement } = await axios.put<T>(`${this.apiUrl}/${key}${subPath}`, {
                    id: key,
                    ...element,
                })

                resolve(rntElement)
            } catch (err) {
                reject(err)
            }
        })
    }
}
